// extracted by mini-css-extract-plugin
export default {"Form":"XEpnY5sIJGufIOX4uUTZ"};